import SpentChart from '@widgets/dashboard/SpentChart';
import { DialogContent } from '@mui/material';
import { useSpentStatistics } from '@app/api/dashboard/useDashboard';

export default function ViewChartDialog({ data, type = 'team' }) {
  const { statistics } = useSpentStatistics(
    type === 'user' ? { user_id: data.id } : { group_id: data.id },
  );

  return (
    <DialogContent className="teamSpentChart">
      <SpentChart statistics={statistics} />
    </DialogContent>
  );
}
